// Top-bar connection-state indicator. Click -> the integrations tab of
// the Settings area (readable by staff). Counts only what a server
// probe verified; before any answer it names itself and claims nothing.
import { useNavigate } from "react-router-dom";
import { integrationCounts, resolveIntegrations } from "../../data/integrations";
import { useIntegrationsStatus } from "../../hooks/useIntegrationsStatus";

export function ConnectionsPill() {
  const navigate = useNavigate();
  // Shared query key: the /settings/integrations page reuses this
  // answer instead of refetching.
  const statusQ = useIntegrationsStatus();
  const counts = integrationCounts(resolveIntegrations(statusQ.data));
  return (
    <button
      className={"v2-conn-pill " + counts.pillTone}
      onClick={() => navigate("/settings/integrations")}
      title="Connection status"
    >
      <span className="dot" />
      {counts.pillText}
    </button>
  );
}
